import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Can } from "src/helpers/Auth";

export const Checkbox = (props) => {
  const [isSelected, setIsSelected] = useState(false);
  useEffect(() => {
    setIsSelected(props.selectAll);
  }, [props.selectAll]);

  useEffect(() => {
    if (props.selectAll) {
      props.updateSelected(props.row);
      setIsSelected(!isSelected);
    }
  }, [props.selectAll]);

  return (
    <Can
      perform="admin"
      yes={() => (
        <input
          disabled={props.row.deleted}
          type="checkbox"
          checked={props.row.deleted ? false : isSelected}
          onChange={() => {
            props.updateSelected(props.row);
            setIsSelected(!isSelected);
          }}
        />
      )}
    />
  );
};

Checkbox.propTypes = {
  row: PropTypes.object,
  updateSelected: PropTypes.func,
  selectAll: PropTypes.bool,
};
